module.exports = __webpack_public_path__ + "base_circular_niver.png?0db86573925fb12a9ba2183441f25b6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base_circular_niver.png
// module id = 10
// module chunks = 0